var map = {
	"./10Ton-PickUp-gray.png": 22316,
	"./10Ton-PickUp-green.png": 25722,
	"./10Ton-PickUp-red.png": 76651,
	"./10Ton-PickUp-yellow.png": 36354,
	"./2Ton-PickUp-gray.png": 47163,
	"./2Ton-PickUp-green.png": 30494,
	"./2Ton-PickUp-red.png": 11948,
	"./2Ton-PickUp-yellow.png": 28586,
	"./3Ton-PickUp-gray.png": 92630,
	"./3Ton-PickUp-green.png": 11453,
	"./3Ton-PickUp-red.png": 61252,
	"./3Ton-PickUp-yellow.png": 82081,
	"./5Ton-PickUp-gray.png": 38033,
	"./5Ton-PickUp-green.png": 77078,
	"./5Ton-PickUp-red.png": 86359,
	"./5Ton-PickUp-yellow.png": 62869,
	"./Ambulance-gray.png": 40895,
	"./Ambulance-green.png": 66406,
	"./Ambulance-red.png": 69122,
	"./Ambulance-yellow.png": 43245,
	"./Bobcat-gray.png": 90799,
	"./Bobcat-green.png": 56283,
	"./Bobcat-red.png": 22752,
	"./Bobcat-yellow.png": 91306,
	"./Boom-Loader-gray.png": 31343,
	"./Boom-Loader-green.png": 50543,
	"./Boom-Loader-red.png": 14101,
	"./Boom-Loader-yellow.png": 93871,
	"./Bulldozer-gray.png": 68570,
	"./Bulldozer-green.png": 7235,
	"./Bulldozer-red.png": 40479,
	"./Bulldozer-yellow.png": 17516,
	"./Canter-gray.png": 99670,
	"./Canter-green.png": 44959,
	"./Canter-red.png": 45260,
	"./Canter-yellow.png": 77360,
	"./Car-gray.png": 72113,
	"./Car-gray1.png": 18704,
	"./Car-gray2.png": 70290,
	"./Car-green.png": 55442,
	"./Car-green1.png": 92212,
	"./Car-green2.png": 31911,
	"./Car-grey.png": 54928,
	"./Car-red.png": 71330,
	"./Car-red1.png": 17337,
	"./Car-red2.png": 67737,
	"./Car-yellow.png": 18908,
	"./Car-yellow1.png": 78022,
	"./Car-yellow2.png": 23827,
	"./Coaster-Bus-gray.png": 33498,
	"./Coaster-Bus-green.png": 81136,
	"./Coaster-Bus-red.png": 21698,
	"./Coaster-Bus-yellow.png": 77186,
	"./Crane-gray.png": 95690,
	"./Crane-green.png": 14117,
	"./Crane-red.png": 30718,
	"./Crane-yellow.png": 17780,
	"./Dumper-gray copy.png": 57558,
	"./Dumper-gray.png": 15837,
	"./Dumper-green.png": 95730,
	"./Dumper-red.png": 46150,
	"./Dumper-yellow.png": 71749,
	"./Excavator-gray.png": 84038,
	"./Excavator-green.png": 81596,
	"./Excavator-red.png": 14002,
	"./Excavator-yellow.png": 58284,
	"./Forklif-gray.png": 4413,
	"./Forklif-green.png": 48481,
	"./Forklif-red.png": 56190,
	"./Forklif-yellow.png": 18431,
	"./Hiace-gray.png": 15175,
	"./Hiace-green.png": 10227,
	"./Hiace-red.png": 90867,
	"./Hiace-yellow.png": 39557,
	"./Hilux-gray.png": 23253,
	"./Hilux-green.png": 61541,
	"./Hilux-red.png": 68608,
	"./Hilux-yellow.png": 15880,
	"./JCB-gray.png": 33845,
	"./JCB-green.png": 39473,
	"./JCB-red.png": 59947,
	"./JCB-yellow.png": 80852,
	"./Mini-Bus-gray.png": 75841,
	"./Mini-Bus-green.png": 10362,
	"./Mini-Bus-red.png": 29657,
	"./Mini-Bus-yellow.png": 23802,
	"./Motorcycle-gray.png": 28497,
	"./Motorcycle-green.png": 83532,
	"./Motorcycle-red.png": 80838,
	"./Motorcycle-yellow.png": 48487,
	"./NewCarGray.png": 10891,
	"./NewCarGreen.png": 70996,
	"./NewCarRed.png": 15517,
	"./NewCarYellow.png": 79521,
	"./PickUp-gray.png": 94723,
	"./PickUp-green.png": 80923,
	"./PickUp-red.png": 76026,
	"./PickUp-yellow.png": 15613,
	"./Reefer-gray.png": 80963,
	"./Reefer-green.png": 94780,
	"./Reefer-red.png": 73063,
	"./Reefer-yellow.png": 90200,
	"./Roller-gray.png": 45959,
	"./Roller-green.png": 12079,
	"./Roller-red.png": 84140,
	"./Roller-yellow.png": 7945,
	"./SUV-gray.png": 40185,
	"./SUV-green.png": 22610,
	"./SUV-red.png": 28325,
	"./SUV-yellow.png": 27539,
	"./SchoolBus-gray.png": 93439,
	"./SchoolBus-green.png": 69760,
	"./SchoolBus-red.png": 5124,
	"./SchoolBus-yellow.png": 20598,
	"./Shovel-gray.png": 91585,
	"./Shovel-green.png": 24356,
	"./Shovel-red.png": 6032,
	"./Shovel-yellow.png": 78222,
	"./Smart Phone-gray.png": 89143,
	"./Sweeper-green.png": 28461,
	"./Sweeper-grey.png": 42262,
	"./Sweeper-red.png": 28488,
	"./Sweeper-yellow.png": 31571,
	"./Tanker-gray.png": 88928,
	"./Tanker-green.png": 82959,
	"./Tanker-red.png": 27992,
	"./Tanker-yellow.png": 51506,
	"./Tourist-Bus-gray.png": 52816,
	"./Tourist-Bus-green.png": 30651,
	"./Tourist-Bus-red.png": 15963,
	"./Tourist-Bus-yellow.png": 56795,
	"./Trailer-gray.png": 63897,
	"./Trailer-green.png": 63964,
	"./Trailer-red.png": 70143,
	"./Trailer-yellow.png": 89338,
	"./Truck-gray.png": 68865,
	"./Truck-green.png": 98882,
	"./Truck-red.png": 12655,
	"./Truck-yellow.png": 52399,
	"./Urvan-gray.png": 20332,
	"./Urvan-green.png": 66547,
	"./Urvan-red.png": 32034,
	"./Urvan-yellow.png": 92803,
	"./Van-gray.png": 53827,
	"./Van-green.png": 81035,
	"./Van-red.png": 49809,
	"./Van-yellow.png": 53453,
	"./Yatch-gray.png": 13194,
	"./Yatch-green.png": 12967,
	"./Yatch-purple.png": 2505,
	"./Yatch-red.png": 85609,
	"./Yatch-yellow.png": 65563,
	"./alert-icon-green.png": 47957,
	"./alert-icon-red.png": 50503,
	"./battery-green-icon.png": 61950,
	"./battery-red-icon.png": 18230,
	"./car-icon-blue.png": 22975,
	"./default-gray.png": 10448,
	"./default-gray1.png": 11690,
	"./default-gray2.png": 60665,
	"./default-green.png": 85980,
	"./default-green1.png": 46962,
	"./default-green2.png": 14928,
	"./default-red.png": 53593,
	"./default-red1.png": 43709,
	"./default-red2.png": 18321,
	"./default-yellow.png": 60601,
	"./default-yellow1.png": 90237,
	"./default-yellow2.png": 33486,
	"./gps-icon-on-green.png": 20646,
	"./gps-icon-on-red.png": 94204,
	"./green-icon.png": 20297,
	"./ignition-icon-off-red.png": 11037,
	"./ignition-icon-off.png": 66597,
	"./ignition-icon-on.png": 99786,
	"./map-icon.png": 42121,
	"./red-icon.png": 30528,
	"./share-icon.png": 82219,
	"./yellow-icon.png": 82750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90369;